import React from "react";

import { useFormatName } from "src/common/hooks/useFormatName";
import { RawUser, User } from "src/views/user-list/types";

export function useNormalizeUser(): (user: RawUser) => User {
	const formatName = useFormatName();
	return React.useCallback(
		({
			id,
			title = "",
			firstName,
			lastName,
			email,
			inactive
		}: RawUser): User => ({
			id,
			email,
			name: formatName({
				title,
				firstName,
				lastName
			}),
			inactive
		}),
		[formatName]
	);
}
